var _defs, _path, _rect, _rect2, _rect3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorreo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c3a536;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.63,161.2H38.37c-9.95,0-18.04-8.09-18.04-18.04V56.84c0-9.95,8.09-18.04,18.04-18.04h123.26c9.95,0,18.04,8.09,18.04,18.04v86.32c0,9.95-8.09,18.04-18.04,18.04ZM38.37,48.8c-4.43,0-8.04,3.61-8.04,8.04v86.32c0,4.43,3.61,8.04,8.04,8.04h123.26c4.43,0,8.04-3.61,8.04-8.04V56.84c0-4.43-3.61-8.04-8.04-8.04H38.37Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.37,
    y: 151.2,
    width: 123.26,
    height: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 137.62,
    y: 85.73,
    width: 10,
    height: 78.6,
    transform: "translate(-46.44 140.17) rotate(-45.82)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.3,
    y: 120.15,
    width: 78.96,
    height: 10,
    transform: "translate(-70.89 75.7) rotate(-44.19)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "100.26 118.38 28.79 48.9 35.76 41.73 100.26 104.44 164.57 41.92 171.54 49.09 100.26 118.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo);
export default __webpack_public_path__ + "static/media/correo.233dc23916622e3e3b63d64771283586.svg";
export { ForwardRef as ReactComponent };